// src/services/CategoryAdminService.js
import http from "./httpService";

class CategoryAdminService {
  async getAll(params) {
    const url = http.getUrlWithParams("/admin/categories", params);
    return await http.get(url);
  }

  async getById(id) {
    const url = `/admin/categories/${id}`;
    return await http.get(url);
  }

  async create(category) {
    const url = "/admin/categories";
    return await http.post(url, category);
  }

  async update(id, category) {
    const url = `/admin/categories/${id}`;
    return await http.put(url, category);
  }

  async remove(id) {
    const url = `/admin/categories/${id}`;
    return await http.delete(url);
  }

  async getCategoriesLesson(params) {
    const newParams = {
      ...params,
      sort_by: "id",
      order: "desc",
    };
    const url = http.getUrlWithParams("/admin/categories/dropdown", newParams);
    return await http.get(url);
  }

  async getStandardCategories() {
    const url = "/admin/categories/dropdown";
    const params = {
      search: "standard",
    };
    const urlWithParams = http.getUrlWithParams(url, params);
    return await http.get(urlWithParams);
  }
}

export default new CategoryAdminService();
